import { CheckCircle, FileText, Upload } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { apiPost } from '../../api/client';
import { useWorkspace } from '../../context/WorkspaceContext';
import { ErrorState } from '../ui/ErrorState';

export function BookkeepingPage() {
  const { workspace } = useWorkspace();
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);
  const [msg, setMsg] = useState(null);

  const sync = async () => {
    setLoading(true);
    setErr(null);
    try {
      await apiPost('/api/sync-accounting', { workspace, transactions: [] });
      setMsg('Sync request completed.');
    } catch (e) {
      setErr(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto max-w-4xl space-y-6 p-4">
      <div className="flex items-center justify-between gap-4">
        <h1 className="text-2xl font-bold text-slate-900">Bookkeeping</h1>
        <Link to="/dashboard" className="text-sm font-medium text-blue-600 hover:underline">
          ← Dashboard
        </Link>
      </div>
      <p className="text-slate-600">
        Upload statements and categorize transactions. Demo: use the API from the worker; dashboard shows
        only <strong>synced</strong> entries.
      </p>
      {err && <ErrorState message={err} />}
      {msg && <p className="text-sm text-emerald-700">{msg}</p>}
      <div className="rounded-2xl border-2 border-dashed border-slate-300 bg-slate-50 p-10 text-center">
        <Upload className="mx-auto h-12 w-12 text-slate-400" />
        <p className="mt-4 font-semibold text-slate-800">Upload bank or card statement</p>
        <p className="mt-1 text-sm text-slate-500">PDF, Excel, CSV, images — connect worker + D1 for full flow.</p>
        <label className="mt-4 inline-block cursor-pointer rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700">
          Choose file
          <input type="file" className="hidden" accept=".pdf,.csv,.xlsx,.png,.jpg" readOnly />
        </label>
      </div>
      <button
        type="button"
        onClick={sync}
        disabled={loading}
        className="inline-flex items-center gap-2 rounded-lg bg-emerald-600 px-4 py-2 text-sm font-semibold text-white hover:bg-emerald-700 disabled:opacity-50"
      >
        <CheckCircle className="h-4 w-4" />
        {loading ? 'Syncing…' : 'Sync to Tally (demo)'}
      </button>
      <div className="rounded-xl border border-slate-200 bg-white p-4">
        <h2 className="flex items-center gap-2 font-semibold text-slate-900">
          <FileText className="h-5 w-5" />
          Tips
        </h2>
        <ul className="mt-2 list-inside list-disc text-sm text-slate-600">
          <li>Run <code className="rounded bg-slate-100 px-1">npm run worker:dev</code> for APIs</li>
          <li>Run <code className="rounded bg-slate-100 px-1">npm run db:init</code> to seed dashboard data</li>
        </ul>
      </div>
    </div>
  );
}
